<template>
  <IQOS :title="$t('marketplace_policy.title')" required>
    <BaseCheckbox class="mt-16" :value="agreed" @input="changeAgreed"
      >{{ $t("marketplace_policy.agreed") }}

      <a
        class="marketplace-link green-5-color"
        :href="policyDocumentLink"
        target="_blank"
      >
        {{ $t("marketplace_policy.agreed_link") }}
      </a>
    </BaseCheckbox>
    <p class="iqos-comment mt-16 c-grey">
      {{ $t("marketplace_policy.link") }}
    </p>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import RoundCheckbox from "@/components/RoundCheckbox.vue";

export default {
  data() {
    return {};
  },
  methods: {
    changeAgreed(v) {
      this.$store.commit("setMarketplaceAgreed", !this.agreed);

      this.$store.dispatch("saveCafe");
    },
  },
  computed: {
    agreed() {
      return this.$store.state.cafe.marketplace_agreed;
    },
    policyDocumentLink() {
      return `/docs/qrwaiter-marketplace-policy-${this.$i18n.locale}.pdf`;
    },
  },
  components: {
    IQOS,
    RoundCheckbox,
  },
};
</script>

<style scoped>
.marketplace-link {
  text-decoration: underline;
  color: #129b81 !important;
}
</style>
